<template>
    <!--/* POPIN avantages des remises open */-->
    <ob1-popin-modal2
        :id="popinModal.id"
        :aria-labelledby="popinModal.label"
        :show-close-button="popinModal.showCloseButton"
    >
        <h4 id="modalTitle">
            {{ dto.title }}
        </h4>
        <div class="row pt-2">
            <div class="col-12">
                <div v-if="popinSections && popinSections.length" id="modalContent">
                    <div v-for="(section, index) in popinSections" :key="index">
                        <div class="alert-container h-100 px-0 mb-0">
                            <p class="alert">
                                <span class="alert-icon" :class="[section.icon]" aria-hidden="true" />
                                <span class="ob1-alert-title" v-html="section.title" />
                            </p>
                            <div class="alert-content">
                                <p class="alert-text" v-html="section.paragraph" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ob1-popin-modal2>
</template>

<script>
export default {
    name: "DiscountAdvantagesPopin",
    props: {
        dtoFromObject: {
            type: Object,
            required: true,
            default: undefined
        },
        dtoFromJson: {
            type: String,
            required: false,
            default: ""
        }
    },
    computed: {
        dto() {
            return typeof this.dtoFromObject === "object" && this.dtoFromObject || JSON.parse(this.dtoFromJson)
        },
        popinModal() {
            return this.dto.popinModal
        },
        popinSections() {
            return this.dto.sections
        }
    },
    methods: {
    }
};
</script>

<style scoped lang="scss">
</style>
